import React from 'react';
import inflection from 'inflection';

import styles from './feedHeadingStyles';

import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';
import EmployerAssociation from 'buyside/components/presentation/EmployerAssociation/employerAssociation';
import Badges from 'buyside/components/presentation/Badges/badges';
import Link from 'buyside/components/presentation/Link/link';
import AnonymousUserDisplay from 'buyside/components/presentation/AnonymousUserDisplay/anonymousUserDisplay';

import { ideaUrl, userUrl } from 'buyside/util/urlHelper';
import separateWithDots from 'buyside/util/separateWithDots';
const { eventTypes, sumzeroSystemUser } = require('buyside/util/constantsFromRails.json');

const FeedHeading = ({ user, createdAt, headerType, idea, showUserDetails }) => {
  const isSystemUser = user.id === sumzeroSystemUser;

  let displayText = '';
  switch (headerType) {
    case eventTypes.publishIdea:
      displayText = 'posted an idea';
      break;
    case eventTypes.publishIdeaUpdate:
      if (!idea) break;
      displayText = (
        <span>
          posted an idea update on&nbsp;
          <Link to={ideaUrl(idea.id)}>
            {separateWithDots(
              idea.positions.map(
                position =>
                  `${inflection.titleize(position.asset.entity.name)} (${
                    position.asset.primarySymbol
                  })`
              )
            )}
          </Link>
        </span>
      );
      break;
    case eventTypes.publishPost || eventTypes.publishAdminPost:
      displayText = 'posted this';
      break;
    case eventTypes.publishWhitePaper:
      displayText = 'posted a Macro/Thematic report';
      break;
    default:
      displayText = 'posted this';
      break;
  }

  let employerLink, headerLink;
  if (isSystemUser) {
    headerLink = <span className={styles.adminPostHeading}>{user.displayName}</span>;
    employerLink = '';
  } else if (showUserDetails) {
    headerLink = <Link to={userUrl(user.id)}>{user.displayName}</Link>;
    employerLink = <EmployerAssociation mostRecentEmployer={user.mostRecentEmployer} />;
  } else {
    headerLink = <AnonymousUserDisplay anonUser={user} showArticle articleCaps />;
    employerLink = '';
  }

  return (
    <div className={styles.postHeading}>
      {showUserDetails && <ProfileImage source={user.profileImageUrl} size="small" />}
      <div className={styles.postHeadingContent}>
        <div>
          {headerLink} {displayText}.
          <div className={styles.categoryGroup}>
            <div className={styles.categoryGroupItem}>
              {employerLink}
              {[eventTypes.publishPost, eventTypes.publishAdminPost].includes(headerType) && (
                <p className={styles.postHeadingTimestamp}>
                  {<span>Published {createdAt} ago</span>}
                </p>
              )}
            </div>
          </div>
        </div>
        {showUserDetails && (
          <div className={styles.categoryGroupAwards}>
            {user.featuredRank && (
              <div className={styles.viewerRanking}>
                Ranking: <strong>{user.featuredRank.rankString}</strong>
              </div>
            )}
            {!!user.userBadges.edges.length &&
              user.userBadges.edges.some(edge => edge.node && edge.node.visible) && (
                <div className={styles.badgesGroup}>
                  Badges:{' '}
                  <Badges userBadges={user.userBadges.edges} inline badgeClass={styles.tinyBadge} />
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
};

export default FeedHeading;
